// Copyright (c) 2017 VMware, Inc. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
export class CreateEditPolicy {
  policyId: number;
  name: string;
  description: string;
  enable: boolean;
  targetId: number;
  targetName: string;
  endpointUrl: string;
  username: string;
  password: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/create-edit-policy/create-edit-policy.ts